<template>
  <section class="about-us-banner">
    <MainBanner :heading="heading" :desc="desc" />

  </section>
</template>

<script setup>
import MainBanner from "../Global/MainBanner.vue";
const heading = "Reviews";
const desc = "Reviews play a pivotal role in the growth and success of any organization. They not only reflect the satisfaction of customers but also serve as a testament to the quality of products or services provided. ";
</script>

<style scoped>
.about-us-banner {
  background-image: linear-gradient(to right, rgba(0, 29, 51, 0.8), rgba(90, 99, 105, 0.8)), url("../../assets//v-1.1/Banners/reviews-banner.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 5.5rem;
}
</style>